export const toUpperFirstSymbol = (str: string) => {
  if (typeof str !== 'string' || str.length < 1) return str;

  return `${str[0].toUpperCase()}${str.slice(1)}`;
};

export const toDownFirstSymbol = (str: string) => {
  if (typeof str !== 'string' || str.length < 1) return str;

  return `${str[0].toLowerCase()}${str.slice(1)}`;
};

export const isInclude = (base: string, search?: string) => {
  return search && base.toLowerCase().includes(search.toLowerCase());
};
